import React from 'react';
import {formatDate, formatDocumentOrganizationUnit} from 'utils/valueFormatter.function';
import {DocumentAmountFieldWithWarnings} from "./DocumentAmount.component";
import {CostCentersDetails} from "./CostCentersDetails.component";
import {formatWarnings} from "../formatWarnings";
import {WarningIcon, WarningsTooltip} from "./WarningsTooltip.component";
import {PreApprovedDetails} from "./PreApprovalDetails.component";
import {Tooltip} from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

const InvoiceDocumentDetailsDTO = ({details, translate}) => {
    let displayId = details.displayId ? details.displayId : details.documentId;

    let formattedWarnings = formatWarnings(details.warnings);

    return (
        <div>
            {details.description &&
                <span>
                    <div className={`document-data-field ${formattedWarnings.description ? 'has-warning' : ''}`}
                         data-tip="description-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.description")}
                            {formattedWarnings.description && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="description-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {details.description}
                            <Tooltip id="description-value-tooltip" content={() => details.description}/>
                        </div>
                    </div>
                    {formattedWarnings.description &&
                        <WarningsTooltip id="description-tooltip" warnings={formattedWarnings.description}/>
                    }
                </span>
            }
            <div className="document-data-divided">
                {details.branch && (details.branch.branchCd || details.branch.name) &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.branch")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="branch-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {details.branch.name ? details.branch.name : details.branch.branchCd}
                        <Tooltip id="branch-value-tooltip" content={() => details.branch.name ? details.branch.name : details.branch.branchCd}/>
                    </div>
                </div>}

                {details.supplierName &&
                <span>
                    <div className={`document-data-field third ${formattedWarnings.supplierName ? 'has-warning' : ''}`}
                         data-tip="supplierName-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.supplierName")}
                            {formattedWarnings.supplierName && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="supplierName-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {details.supplierName}
                            <Tooltip id="supplierName-value-tooltip" content={() => details.supplierName}/>
                        </div>
                    </div>
                    {formattedWarnings.supplierName &&
                    <WarningsTooltip id="supplierName-tooltip" warnings={formattedWarnings.supplierName}/>
                    }
                </span>
                }

                {details.supplierNumber &&
                <span>
                    <div className={`document-data-field third ${formattedWarnings.supplierNumber ? 'has-warning' : ''}`}
                         data-tip="supplierNumber-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.supplierNumber")}
                            {formattedWarnings.supplierNumber && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="supplierNumber-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {details.supplierNumber}
                            <Tooltip id="supplierNumber-value-tooltip" content={() => details.supplierNumber}/>
                        </div>
                    </div>
                    {formattedWarnings.supplierNumber &&
                    <WarningsTooltip id="supplierNumber-tooltip" warnings={formattedWarnings.supplierNumber}/>
                    }
                </span>
                }
                {details.invoiceNumber &&
                <span>
                    <div className={`document-data-field third ${formattedWarnings.invoiceNumber ? 'has-warning' : ''}`}
                         data-tip="invoiceNumber-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.invoiceNumber")}
                            {formattedWarnings.invoiceNumber && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="invoiceNumber-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {details.invoiceNumber}
                            <Tooltip id="invoiceNumber-value-tooltip" content={() => details.invoiceNumber}/>
                        </div>
                    </div>
                    {formattedWarnings.invoiceNumber &&
                    <WarningsTooltip id="invoiceNumber-tooltip" warnings={formattedWarnings.invoiceNumber}/>
                    }
                </span>
                }

                {details.creditBankAccount &&
                <span>
                    <div
                        className={`document-data-field third ${formattedWarnings.creditBankAccount ? 'has-warning' : ''}`}
                        data-tip="creditBankAccount-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.bankAccount")}
                            {formattedWarnings.creditBankAccount && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="creditBankAccount-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {details.creditBankAccount}
                            <Tooltip id="creditBankAccount-value-tooltip" content={() => details.creditBankAccount}/>
                        </div>
                    </div>
                    {formattedWarnings.creditBankAccount &&
                    <WarningsTooltip id="creditBankAccount-tooltip" warnings={formattedWarnings.creditBankAccount}/>
                    }
                </span>
                }

                {details.vendorReference &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.vendorReference")}
                    </div>
                    <div className="document-data-field-value">
                        {details.vendorReference ? details.vendorReference : details.invoiceNumber}
                    </div>
                </div>}

                {displayId &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.documentID")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="documentId-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {displayId}
                        <Tooltip id="documentId-value-tooltip" content={() => displayId}/>
                    </div>
                </div>}

                {details.invoiceDate &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.invoiceDate")}
                    </div>
                    <div className="document-data-field-value">
                        {formatDate(details.invoiceDate)}
                    </div>
                </div>}

                {details.dueDate &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.dueDate")}
                    </div>
                    <div className="document-data-field-value">
                        {formatDate(details.dueDate)}
                    </div>
                </div>}

                {details.amount !== null &&
                <DocumentAmountFieldWithWarnings details={details} warnings={formattedWarnings.amount} translate={translate}/>
                }

                {details.documentOrganizationUnit &&
                <span>
                    <div
                        className={`document-data-field third ${formattedWarnings.documentOrganizationUnit ? 'has-warning' : ''}`}
                        data-tip="documentOrganizationUnit-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        <div className="document-data-field-label">
                            {translate("documentData.documentOrganizationUnit")}
                            {formattedWarnings.documentOrganizationUnit && <WarningIcon/>}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="documentOrganizationUnit-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                            {formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                            <Tooltip id="documentOrganizationUnit-value-tooltip" content={() => formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>
                        </div>
                    </div>
                    {formattedWarnings.documentOrganizationUnit &&
                    <WarningsTooltip id="documentOrganizationUnit-tooltip"
                                     warnings={formattedWarnings.documentOrganizationUnit}/>
                    }
                </span>
                }
                {details.paymentPreApprovalDetails &&
                <PreApprovedDetails
                    translate={translate}
                    paymentDetails={details.paymentPreApprovalDetails}
                />}
            </div>

            {details.documentCostUnitList && details.documentCostUnitList.length > 0 &&
            <CostCentersDetails costUnitList={details.documentCostUnitList}
                                translate={translate}/>}
        </div>
    )
};


export default InvoiceDocumentDetailsDTO;